















import Vue from "vue";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";

export default Vue.extend({
  name: "returnToDesktop",
  data() {
    return {
      TRANSLATION_KEY: "steps.ReturnToDesktop",
      requestCount: 0,
      maxRequests: 3,
    };
  },
  methods: {
    switchToNextStep() {
      if (this.requestCount >= this.maxRequests) {
        return;
      }
      this.requestCount++;
      const ajaxService = this.$store.state.ajaxService;
      ajaxService.post(ajaxService.PROXY_ROUTE + "document/mobile-return-to-desktop", {
        token: ajaxService.getToken(),
      });

      if (this.requestCount < this.maxRequests) {
        setTimeout(() => {
          this.switchToNextStep();
        }, 3000); 
      }
    },
  },
  computed: {
    ...mapState({
      responseData: (state: any) => state.formData,
    }),
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 4);
    this.switchToNextStep();
  },
});
